module.exports = __webpack_public_path__ + "img/boton-oficina.56eb036b.jpg";